import { useState, useEffect } from 'react';
import { GridCounters } from '@/lib/db/supabase-grid-counter';
import { useLanguage } from '@/lib/i18n/language-provider';
import { getApiUrl } from '@/lib/api-url';

export function GridCounter() {
  const { t } = useLanguage();
  const [counters, setCounters] = useState<GridCounters>({
    classicMode: 0,
    multiGridMode: 0,
    total: 0,
    visits: 0
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCounters() {
      try {
        setIsLoading(true);
        const response = await fetch(getApiUrl('/api/grid-counters'));
        
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des compteurs');
        }
        
        const data = await response.json();
        setCounters(data);
        setError(null);
      } catch (err) {
        // console.error('Erreur:', err);
        setError('Impossible de charger les statistiques');
      } finally {
        setIsLoading(false);
      }
    }
    
    fetchCounters();
    
    // Rafraîchir les compteurs toutes les 5 minutes
    const interval = setInterval(fetchCounters, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  if (isLoading) {
    return <div className="text-xs text-muted-foreground opacity-70">Chargement des statistiques...</div>;
  }

  if (error) {
    return null; // Ne rien afficher en cas d'erreur
  }

  return (
    <div className="flex flex-col items-center text-xs text-muted-foreground">
      <div className="flex gap-4 items-center">
        <span>{t('footer.gridsCreated') || 'Grilles créées'}:</span>
        <div className="grid grid-cols-4 gap-2">
          <div className="flex flex-col items-center">
            <span className="font-medium">{counters.classicMode}</span>
            <span className="text-[10px]">{t('footer.classicMode') || 'Mode classique'}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="font-medium">{counters.multiGridMode}</span>
            <span className="text-[10px]">{t('footer.multiGridMode') || 'MultiGrid'}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="font-medium">{counters.total}</span>
            <span className="text-[10px]">{t('footer.total') || 'Total'}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="font-medium">{counters.visits}</span>
            <span className="text-[10px]">{t('footer.visits') || 'Visites'}</span>
          </div>
        </div>
      </div>
    </div>
  );
} 